<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
<!--            <div class="logo-form">-->
<!--&lt;!&ndash;              <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo-brainiac.svg'" alt="">&ndash;&gt;-->
<!--            </div>-->
            <div class="form-title">
              <span>{{ getTranslations.visitor_two_step_registration_send_sms }}</span>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="twoStepRegSteps_Container">
              <div class="twoStepRegSteps_step">1</div>
              <div class="twoStepRegSteps_step inactive">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <img class="form-help__icon" src="static/images/mobile-icon.svg" alt="">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
            </div>
            <form action="">
              <div class="form-group form-group--mobile form-group form-group--icon" :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text"  pattern="[0-9]*" inputmode="numeric" class="mobile form-group__textfield phone_input"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check" v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a :href="getTranslations.project_config_visitor_register_3_terms_and_conditions" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>
              <input type="submit" :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( hasErrors || waitForResponse )? 'deactivated' : '']" @click.prevent="checkButton">

              <p>
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </p>

              <div class="form-footer-text">
                {{ getTranslations.visitor_sign_up_1_single_country_disclaimer }}
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';

export default {
  name: 'two-step-sign-up-1',
  mixins: [IntegrationMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getHeIntegration(to);
    });
  },
  created() {
    const inputMsisdn = this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    getHeIntegration(to) {
      this.getIntegrationParametersCheck()(to);
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    check: function check() {
      const validPinRegex = /^[a-zA-Z0-9]{0,10}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (!this.hasErrors && this.user.pin.length > 0 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        this.$axios.get(`api/verifyPin?pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}`).then((response) => {
          this.waitForResponse = false;
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.setRegistrationInfo(response.data.data.msisdn);
            this.$gtm.trackEvent({
              event: 'CompleteRegistration',
              category: 'MSISDN Registration',
              action: 'Two Step Register 2 registration',
              label: 'Two Step Register 2',
            });
            this.$router.push('twostepregister2');
          } else {
            if (res === 'PIN_EXPIRED') {
              this.message = 'visitor_sign_up_2_pin_expired';
            } else if (res === 'WRONG_PIN') {
              this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
            } else if (res === 'BLOCKED_USER') {
              this.message = 'visitor_forgot_password_warning_msd_max_attempts';
            } else if (res === 'SERVER_ERROR') {
              this.message = 'home_profile_profile_edit_server_unvailable';
            } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
              this.message = 'visitor_sign_up_warning_third_party_error';
            } else if (res === 'ALREADY_REGISTERED') {
              this.message = 'visitor_sign_up_msisdn_already_registered';
            }
            this.hasErrors = true;
          }
        });
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/TwoStepRegistration1.vue